import { Localized } from "@fluent/react";

import styles from "./InternationalEnrollmentForm.module.scss";
import PrimaryChoiceContainer from "../PrimaryChoiceContainer/PrimaryChoiceContainer";
import type { PrimaryChoiceConfig } from "../PrimaryChoiceContainer/types";

type InternationalEnrollmentFormProps = {
  primaryChoiceConfig: PrimaryChoiceConfig | null;
  fields: React.ReactNode[];
  showAccountDetailsHeading: boolean;
};

const InternationalEnrollmentForm = ({
  primaryChoiceConfig,
  fields,
  showAccountDetailsHeading
}: InternationalEnrollmentFormProps) => (
  <>
    <PrimaryChoiceContainer choiceConfig={primaryChoiceConfig} />
    {showAccountDetailsHeading && (
      <div className="margin--top--xl fontWeight--bold margin--bottom--l">
        <Localized id="heading-account-details">Account details</Localized>
      </div>
    )}
    <div className={styles["international-enrollment-form"]}>{fields}</div>
  </>
);

export default InternationalEnrollmentForm;
